import axios, { InternalAxiosRequestConfig } from 'axios';

import { API_ENDPOINT } from '@/constants';

import { acquireToken } from '@/shared/lib/auth';
import { UNAUTHORIZED_PAGES } from 'common/enums';
import { msalInstance } from '@/shared/lib/auth/config';

const axiosInstance = axios.create({ baseURL: `${API_ENDPOINT}/api/` });

export interface CustomInternalAxiosRequestConfig extends InternalAxiosRequestConfig {
  isExcludeToken?: boolean;
}

const exceptionEndpoints = ['fileProvider/getFilesByDocumentType', 'fileProvider/DownloadFile'];

const isUnauthorizedPage = Object.values(UNAUTHORIZED_PAGES).includes(window.location.pathname as UNAUTHORIZED_PAGES);

axiosInstance.interceptors.request.use(
  async (config: CustomInternalAxiosRequestConfig): Promise<CustomInternalAxiosRequestConfig> => {
    config.headers = config.headers || {};
    config.headers['X-Mobexo-Security'] = 'fc86d81c-d50b-470a-b527-0bec22484a70';

    if (!config.isExcludeToken && !isUnauthorizedPage) {
      const token = await acquireToken();
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      msalInstance.logoutRedirect();
    }
    if (error.response?.status === 404 && !exceptionEndpoints.includes(error.config?.url)) {
      window.dispatchEvent(new Event('unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
